import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import defaultIcon from './../../../assets/icon_bell.png';

import moment from 'moment';
import {
  NotificationComponent,
  InnerWrapper,
  Details,
  Logo,
  Title,
  DesktopMessage,
  MobileMessage,
  Time,
} from './Notification.styles.js';
import NaviagtionLink from 'components/_common/navigation-link';
import  { ReactHtmlParser } from 'helpers/utilities.js';
import PropTypes from 'prop-types';

const Notification = ({
  icon,
  title,
  body,
  dateCreated,
  isRead = false,
  onClick = () => {},
  userId,
  notificationId,
  shortNotification = false,
  notification = {},
  setActiveNotification = () => {},
  activeNotification = {},
  labels,
  notificationReadStatus,
}) => {
  const navigate = useNavigate();
  const { notifications_detail_cta_url } = labels || {};

  const logo = icon?.src?.length > 0 ? icon?.src : defaultIcon;

  const isEllipsisMessage = body.length >= 76 ? body.slice(76).concat('...') : body;

  const time = dateCreated && dateCreated.split(' ')[0];
  const dateParts = time && time.split('/');


  const [notificationIsRead, setNotificationIsRead] = useState(isRead);
  const isNotificationActive = activeNotification.notificationId === notification.notificationId;
  const [notificationTime, setNotificationTime] = useState(0);
  const [elapsedDays, setElapsedDays] = useState();
  useEffect(() => {
    const getToday = new Date();
    const formatToday = moment(getToday)
      .format('YYYY/MM/DD')
      .split('/');
    const arrayToday = formatToday.map(str => {
      return Number(str);
    });
    const formatArrayTime = dateParts.map(str => {
      return Number(str);
    });
    const timeCreated = formatArrayTime.reverse();
    var a = moment(arrayToday);
    var b = moment(timeCreated);
    setNotificationTime(a.diff(b, 'days'));
  }, [dateParts]);
  useEffect(() => {
    const dateToday = moment();
    const b = moment(time, 'DD/MM/YYYY');
    const res = dateToday.diff(b, 'days');
    setElapsedDays(res);
  }, [time]);
  return (
    <NotificationComponent
      read={notificationReadStatus}
      activeNotification={isNotificationActive}
      onClick={() => {
        setNotificationIsRead(true);
        if (!isRead) {
          onClick(notificationId, userId);
        }
        setActiveNotification(notification);
        if (shortNotification) {
          navigate(`?notificationId=${notification.notificationId}`);
        }
      }}
    >
      <NaviagtionLink
        linkHref={
          !shortNotification
            ? `${notifications_detail_cta_url}?notificationId=${notification.notificationId}`
            : ''
        }
        target="_self"
        isExternal={false}
      >
        <InnerWrapper>
          <Details>
            <Logo src={logo} />
            <Title read={notificationIsRead}>{ReactHtmlParser(title)}</Title>
            <DesktopMessage read={notificationIsRead} shortNotification={shortNotification}>
              {isEllipsisMessage}
            </DesktopMessage>
            <Time>
              {elapsedDays > 1 && time}
              {elapsedDays === 1 && 'Yesterday'}
              {elapsedDays === 0 && 'Today'}
            </Time>
          </Details>
          <MobileMessage read={notificationIsRead} shortNotification={shortNotification}>
            {isEllipsisMessage}
          </MobileMessage>
        </InnerWrapper>
      </NaviagtionLink>
    </NotificationComponent>
  );
};

Notification.propTypes = {
  icon: PropTypes.shape({
    src: PropTypes.string,
  }),
  title: PropTypes.string,
  body: PropTypes.string,
  dateCreated: PropTypes.string,
  isRead: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  notificationId: PropTypes.number,
  shortNotification: PropTypes.bool,
  labels: PropTypes.object,
  notification: PropTypes.object,
  activeNotification: PropTypes.object,
  notificationReadStatus: PropTypes.bool,
  notificationTime: PropTypes.string,
  onClick: PropTypes.func,
  setActiveNotification: PropTypes.func,
};

export default Notification;
